import React from 'react'
import ProjectBiddingWizardStep from './BiddingWizardStep'
import {BiddingWizard} from './BiddingWizard'
import BiddingProposalsStep from "./BiddingProposalsStep";
import BiddingTalentStep from "./BiddingTalentStep";
import Project from "../../models/Project";
import BiddingCandidatesStep from "./BiddingCandidatesStep";
import BiddingBriefStep from "./BiddingBriefStep";
import BiddingContractSummarySubstep from "./BiddingContractSummarySubstep";
import BiddingContractApprovalDocumentsSubstep from "./BiddingContractApprovalDocumentsSubstep";
import ReactDOM from "react-dom";
import ProjectSummary from "./components/ProjectSummary";
import {Navigate, Routes, Route, useLocation, useOutletContext, useNavigate} from "react-router-dom";
import {useProject} from "../../providers/ClientProjectProvider";
import {Affix} from "antd";
import UserImageCircle from '../../components/UserImageCircle';
import InfoTooltip from '../../components/InfoTooltip';
import {useAuth} from "../../providers/AuthProvider";

export default class BiddingContractStep extends ProjectBiddingWizardStep {
    static slug = 'contract';

    static path = '/contract';
    static StepName = 'SOW';
    // static StepName = 'Finalize Contract';
    static StepTitle = 'Project SoW';
    static StepHeader = 'Review and approve contract to start project';

    static accomplishedForProject(project) {
        return project.isPendingContract();
    }

    static iconFor(project) {
        return <i className="tab-icon fas fa-file-signature"/>
    }

    static pathForSubstep(props, substep) {
        return `${BiddingWizard.pathFor(
            props.project.id,
            this.slug
        )}/${TB.slugify(substep)}`;
    }

    constructor(props, context) {
        super(props, context);

        this.sowHeaderRef = React.createRef();

        this.state = {
            ...this.state,
            completedSteps: [],
            sowSteps: props.project.sowSteps()
        };
    }

    async componentDidMount() {
        super.componentDidMount();
        if (!this.props.project.isActive()) {
            await this.middlewareCheck(async () => {

                let redirectToStep = (step) => {
                    if (!this.activeStep() || this.activeStep() !== step) {
                        return this.props.navigate(step.SubstepSlug, {replace: true});
                    }
                }

                if (this.props.project.isAwaitingKickoff() || (this.shouldHandleStepNavigation() && this.props.project.hasApprovedLatestContract())) {

                    let completedSteps = TB.filter([...this.state.sowSteps], step => step !== BiddingContractApprovalDocumentsSubstep);

                    // if (TB.find(completedSteps, step => step === BiddingContractContactDetailsSubstep)
                    //     && !BiddingContractContactDetailsSubstep.hasCompletedForProject(this.props.project)) {
                    //     completedSteps = [];
                    // }
                    await this.promisedState({completedSteps});

                    await redirectToStep(BiddingContractApprovalDocumentsSubstep);
                } else {

                    if (this.activeStep()) {
                        let completedSteps = [];
                        let currentStepIndex = this.activeStepIndex();
                        let invalidStep = null;
                        TB.map(this.state.sowSteps, async (validatedStep, stepIndex) => {
                            if (stepIndex < currentStepIndex) {
                                if (!validatedStep?.hasCompletedForProject(this.props.project)) {
                                    invalidStep = validatedStep;
                                } else if (!invalidStep) {
                                    completedSteps.push(validatedStep);
                                }
                            }
                        })

                        await this.promisedState({completedSteps});
                        if (invalidStep) {
                            return redirectToStep(invalidStep)
                        }
                    } else {
                        return redirectToStep(TB.first(this.state.sowSteps))
                    }
                }
                if (this.shouldHandleStepNavigation() && !this.props.project.hasApprovedLatestContract()) {
                    return TB.sysAlert('sow_approval.begin_approval_process');
                }
            })
        } else {
            await this.toggleStartAlert(this.props.project);
        }
    }

    validateProjectMiddleware() {
        let project = this.props.project;

        if (!this.context?.auth?.canViewSOWForProject(project)) {
            let redirectStep = BiddingBriefStep;

            if (this.context?.auth?.canViewTalentForProject(project)) {
                redirectStep = project.isBYO() ? BiddingCandidatesStep : BiddingProposalsStep;
            }

            return {
                key: 'client.tab_visit_project_permission_error',
                redirect: redirectStep,
            };
        }
        if (this.props.project.is_on_hold) {
            return {
                key: 'client.tab_visit_disabled_project_on_hold',
                redirect: BiddingBriefStep,
            };
        }
        if (project.isPendingContract()) {
            return;
        }

        if (project.isAwaitingContract()) {
            let redirectStep = project.isBYO() ? BiddingCandidatesStep : BiddingProposalsStep;


            if (!this.context?.auth?.canViewTalentForProject(project)) {
                redirectStep = BiddingBriefStep;
            }
            return {
                key: (project.isBYO() ? 'byo.' : 'team_shopping.') + 'contract_step_error_awaiting_contract',
                redirect: redirectStep
            };
        } else if (project.isBYO()) {
            if (!project.hasFilledAllPositions()) {
                let redirectStep = BiddingCandidatesStep.accomplishedForProject(project)
                    ? BiddingCandidatesStep
                    : BiddingTalentStep
                if (!this.context?.auth?.canViewTalentForProject(project)) {
                    redirectStep = BiddingBriefStep;
                }
                return {
                    key: 'byo.contract_step_error_missing_filled_roles',
                    redirect: redirectStep
                };
            } else if (!project.hasAnyCandidatesForAnyPositions()) {
                let redirectStep = this.context?.auth?.canViewTalentForProject(project)
                    ? BiddingTalentStep
                    : BiddingBriefStep

                return {
                    key: 'byo.contract_step_error_no_invites_to_proposal',
                    redirect: redirectStep,
                };
            } else if (!project.hasRequestedSOW()) {
                let redirectStep = this.context?.auth?.canViewTalentForProject(project)
                    ? BiddingCandidatesStep
                    : BiddingBriefStep

                return {
                    key: 'byo.contract_step_error_sow_not_requested',
                    redirect: redirectStep,
                };
            }
        } else if (project.isService()) {
            if (project.isSelectingTalent()) {
                let redirectStep = this.context?.auth?.canViewTalentForProject(project)
                    ? BiddingTalentStep
                    : BiddingBriefStep

                return {
                    key: 'team_shopping.contract_step_error_no_requested_proposals',
                    redirect: redirectStep,
                };
            } else if (project.isAcceptingProposals() && !project.hasRequestedSOW()) {
                let redirectStep = this.context?.auth?.canViewTalentForProject(project)
                    ? BiddingProposalsStep
                    : BiddingBriefStep

                return {
                    key: 'team_shopping.contract_step_error_no_selected_team',
                    redirect: redirectStep
                };
            }
        }

    }

    async middlewareCheck(callback) {
        let error = this.validateProjectMiddleware();

        if (!error || !this._isMounted) {
            return callback();
        }

        await TB.sysAlert(error.key);
        return this.props.goToStep(error.redirect);
    }

    hasPrevStep() {
        let activeStepIndex = this.activeStepIndex();

        return activeStepIndex > 0;
    }

    prevStep() {
        let activeStepIndex = this.activeStepIndex();
        activeStepIndex--;

        let prevStep = this.state.sowSteps[activeStepIndex];
        if (!prevStep) {
            return;
        }

        this.props.navigate(prevStep.SubstepSlug, {replace: true});

        this.scrollToStep()
    }

    hasNextStep() {
        let activeStepIndex = this.activeStepIndex();

        return activeStepIndex < (this.state.sowSteps.length - 1);
    }

    nextStep() {
        let activeStepIndex = this.activeStepIndex();
        activeStepIndex++;

        let nextStep = this.state.sowSteps[activeStepIndex];
        if (!nextStep) {
            return;
        }

        this.props.navigate(nextStep.SubstepSlug, {replace: true});
        this.scrollToStep()
    }

    scrollToStep() {
        const node = ReactDOM.findDOMNode(this.sowHeaderRef.current);

        if (node) {
            $('html, body').animate({
                scrollTop: $(node).offset().top - 10
            }, 400);
        }
    }

    activeStep() {
        if (!this.props.project) {
            return;
        }

        return this.state.sowSteps[this.activeStepIndex()]
    }

    activeStepIndex() {
        return TB.findIndex(this.state.sowSteps, (step, index) => {
            return this.props.location.pathname.indexOf(step.SubstepSlug) > -1
        })
    }

    async startProject() {
        if (this.props.project.client_contract_management_setting === Project.ContractSettings.ApprovedOnline && this.activeStep() === BiddingContractApprovalDocumentsSubstep) {
            let confirm = await TB.sysAlert('client.accept_current_sow_confirmation');

            if (!confirm) return;
        } else if (this.state.completedSteps.length !== this.state.sowSteps.length) {
            let confirm = await TB.sysAlert('client.review_all_sow_steps');
            if (!confirm) return;
        }
        await this.promisedState({isDisabled: true})

        let updatedProject = Project.make({id: this.props.project.id});

        updatedProject = await updatedProject.signSowForClient();

        await this.props.updateProject(updatedProject);

        if (!updatedProject) {
            await this.promisedState({isDisabled: false})

            return this.handleErrorResponse(
                Project.SyncRequest
            );
        }

        await this.promisedState({isDisabled: false});
        return this.toggleStartAlert(this.props.project)
    }

    async postUpdateProject(props, goToNextStep = false) {

        if (!this.state.isDisabled) {

            await this.promisedState({isDisabled: true})
            await this.props.toggleUsability(false);

            let updatedProject = await this.props.project.update(props);

            if (!updatedProject) {
                await this.props.toggleUsability(true);
                await this.promisedState({isDisabled: false})

                return this.handleErrorResponse(
                    Project.SyncRequest
                );
            }

            if (!this.state.completedSteps.includes(this.activeStep())) {
                await this.promisedState({completedSteps: [...this.state.completedSteps, this.activeStep()]})
            }

            await this.props.toggleUsability(true);
            await this.promisedState({isDisabled: false});

            if (goToNextStep && this.hasNextStep() &&
                this.activeStep().hasCompletedForProject(this.props.project)) {
                return this.nextStep()
            }
        }

        return false;
    }

    async cancelProjectSOW() {
        let confirm = await TB.sysAlert("byo.cancel_sow_button_click")

        if (confirm) {

            await this.promisedState({isDisabled: true})
            await this.props.toggleUsability(false);

            let updatedProject = Project.make({id: this.props.project.id});

            updatedProject = await updatedProject.cancelSOW();

            await this.props.updateProject(updatedProject);

            if (!updatedProject) {
                await this.props.toggleUsability(true);
                await this.promisedState({isDisabled: false})

                return this.handleErrorResponse(
                    Project.SyncRequest
                );
            }

            await this.props.toggleUsability(true);
            await this.promisedState({isDisabled: false});

            await TB.sysAlert('byo.project_sow_cancelled');

            return this.props.goToStep(this.props.project.isBYO() ? BiddingCandidatesStep : BiddingProposalsStep);
        }
    }

    async cancelProjectSOWApproval() {
        let confirm = await TB.sysAlert("sow_approval.cancel_approval_process")

        if (confirm) {

            await this.promisedState({isDisabled: true})

            await this.props.toggleUsability(false);

            let cancelledApproval = await this.props.project.cancelSOWApproval();

            if (!cancelledApproval) {
                await this.props.toggleUsability(true);
                await this.promisedState({isDisabled: false})

                return this.handleErrorResponse(
                    Project.CancelSOWApprovalRequest
                );
            }

            await this.props.toggleUsability(true);
            await this.promisedState({isDisabled: false, completedSteps: []});

            return this.props.navigate(TB.first(this.state.sowSteps).SubstepSlug, {replace: true});
        }
    }

    async approveLatestSOWContractDetails() {
        if (!this.state.isDisabled) {
            await this.promisedState({isDisabled: true})
            await this.props.toggleUsability(false);

            let updatedProject = await this.props.project.approveSOWContractDetails();

            if (!updatedProject) {
                await this.props.toggleUsability(true);
                await this.promisedState({isDisabled: false})

                return this.handleErrorResponse(
                    Project.ApproveSOWContractDetailsRequest
                );
            }
            let completedSteps = [...this.state.completedSteps];

            completedSteps.push(BiddingContractSummarySubstep);


            await this.props.toggleUsability(true);
            await this.promisedState({isDisabled: false, completedSteps});


            if (this.hasNextStep()) {
                return this.nextStep();
            }
            // await TB.sysAlert('byo.project_sow_cancelled');
        }
    }

    /**
     * @param {function(): Promise<undefined|*>} requestCallback
     * @param {TB.Request} modelRequest
     */
    async makeRequest(requestCallback, modelRequest) {
        if (this.state.isDisabled) return false;

        await this.promisedState({isDisabled: true})
        await this.props.toggleUsability(false);

        let response = await requestCallback();

        await this.props.toggleUsability(true);
        await this.promisedState({isDisabled: false})

        if (!response) {

            await this.handleErrorResponse(modelRequest);
            return false;
        }

        return response;
    }

    async toggleStartAlert(project) {
        if (!project.latestContract()) {
            await TB.alert('confirm', 'Congratulations!',
                'SOW has been approved & signed. Awaiting Talent Onboarding & Project Kickoff.', [{
                    title: 'View Project',
                }]
            );

        } else {
            let viewProject = await TB.sysAlert((project.isBYO() ? 'byo' : 'team_shopping') +
                '.accept_and_start_project_button_clicked');
            if (!viewProject) {
                try {
                    window.open(project.latestContract().path, '_blank');
                } catch (e) {
                    console.log('toggleStartAlert', e);
                }
            }
        }
        if (this.props.project.isActive()) {
            return this.props.navigate(project.detailLink())
        }
    }

    shouldHandleStepNavigation() {
        return this.state.sowSteps.length > 1 && !this.props.project.acceptsStandardSOW()
    }

    renderStepHeader() {
        let acceptsStandardSOW = this.props.project.acceptsStandardSOW();
        let canRequestSOWForProject = this.context?.auth?.canRequestSOWForProject(this.props.project);
        let canCompleteSOWForProject = this.context?.auth?.canCompleteSOWForProject(this.props.project);

        return (
            <React.Fragment>
                {!acceptsStandardSOW && (
                    <React.Fragment>
                        <div className="project-bidding-step-header">
                            <h3>
                                <small>
                                    {this.constructor.stepTitleFor(this.props.project)}
                                </small>
                                {this.constructor.stepHeaderFor(this.props.project)}
                            </h3>
                        </div>
                        <hr className="project-bidding-step-divider"/>
                    </React.Fragment>
                )}
                <div className={TB.mapClass("sow-approval-header", {
                    "mt-2": !acceptsStandardSOW
                })}>

                    {acceptsStandardSOW && (
                        <div className="sow-approval-title">
                            <h3>Project Approval</h3>
                            {!this.props.project.isAwaitingKickoff() && (
                                <React.Fragment>
                                    <h5>Approve SOW</h5>
                                    {this.props.project.hasUploadedManualContract() ? (
                                        <p>Review the contract to approve the statement of work</p>
                                    ) : (
                                        <p>Review each section to approve the statement of work</p>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    )}
                    <div className="sow-approval-brief" ref={this.sowHeaderRef}>

                        <div className="sow-approval-brief-info">
                            <ProjectSummary
                                isContract={true}
                            />

                        </div>

                        {!acceptsStandardSOW && (
                            <div className="flex ml-auto flex-row items-center flex-nowrap">
                                <button
                                    className={TB.mapClass('btn btn-link btn-link-primary mx-4', {'disabled-edit-link': !canRequestSOWForProject})}
                                    disabled={this.state.isDisabled}
                                    onClick={() => {
                                        if (!canRequestSOWForProject) {
                                            return TB.showPermissionError();
                                        }
                                        this.cancelProjectSOW()
                                    }}
                                >
                                    Cancel SOW
                                    {!canRequestSOWForProject && (<i className="fa fa-lock ml-1"/>)}
                                </button>

                                {/*<button*/}
                                {/*    className={TB.mapClass('btn btn-primary', {'disabled-edit-link': !canCompleteSOWForProject})}*/}
                                {/*    disabled={this.state.isDisabled}*/}
                                {/*    onClick={() => {*/}
                                {/*        if (!canCompleteSOWForProject) {*/}
                                {/*            return TB.showPermissionError();*/}
                                {/*        }*/}
                                {/*        this.startProject();*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*    Accept and Start Project*/}
                                {/*    {!canCompleteSOWForProject && (<i className="fa fa-lock ml-1"/>)}*/}
                                {/*</button>*/}
                            </div>
                        )}

                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderSideBarNavLink(step, index) {
        let subStepName = TB.tryTrans(step.getStepName(this.props.project));

        let isActive = TB.includes(this.props.location.pathname, step.SubstepSlug);

        let shouldHandleApproval = this.shouldHandleStepNavigation();

        let isLocked = shouldHandleApproval
            && this.props.project.hasApprovedLatestContract()
            && step !== BiddingContractApprovalDocumentsSubstep;

        let isComplete = this.state.completedSteps.includes(step) || (shouldHandleApproval && isLocked);

        if (shouldHandleApproval && index < this.activeStepIndex()) {
            isComplete = true
        }

        let noClick = isActive || this.state.isDisabled;

        if ((shouldHandleApproval && !this.props.project.hasApprovedLatestContract())
            && step === BiddingContractApprovalDocumentsSubstep) {
            noClick = true;
        }
        if (!isLocked && step !== BiddingContractApprovalDocumentsSubstep && !isComplete) {
            noClick = true;
        }
        if (this.props.project.hasSignedLatestContract()) {
            isComplete = true;
            noClick = false;
        }

        let icon = 'circle';
        if (isComplete) {
            icon = 'check';
        }
        if (isLocked) {
            icon = 'lock';
        }

        return (
            <button key={`stepBtn${step.SubstepSlug}`}
                    className={TB.mapClass(`btn sow-step-btn`, {
                        isActive,
                        'no-click': noClick,
                        isComplete,
                        isLocked
                    })}
                    onClick={e => {
                        if (noClick) {
                            e.preventDefault()
                        } else {
                            this.props.navigate({
                                ...this.props.location,
                                pathname: step.SubstepSlug
                            })
                        }
                    }}>
                <i className={`fa fa-${icon} mr-3`}/>
                {subStepName}
            </button>
        );
    }

    render() {
        if (!this.props.project) {
            return <div/>;
        }

        let error = this.validateProjectMiddleware();

        if (error) {
            // let title = TB.tryTrans('start_project.contract.errors.' + error + '.title'),
            // 	message = TB.tryTrans('start_project.contract.errors.' + error + '.message');

            return <div/>
        }

        let ActiveStep = this.activeStep(),
            activeStepName = ActiveStep && TB.tryTrans(ActiveStep.SubstepName),
            sowSteps = this.state.sowSteps;

        let acceptsStandardSOW = this.props.project.acceptsStandardSOW();
        let shouldHandleStepNavigation = this.shouldHandleStepNavigation();

        let activeStepComplete = this.state.completedSteps.includes(ActiveStep);
        const canCompleteSOWForProject = this.context?.auth?.canCompleteSOWForProject(this.props.project);
        const canEditSOWForProject = this.context?.auth?.canEditSOWForProject(this.props.project);

        return (
            <>
                {this.props.project.isAwaitingKickoff() && (
                    <div className="nav-alert nav-warning">
                        <p>
                            <i className="fa fa-info-circle"/> SOW Signed - Awaiting Talent Onboarding & Project Kickoff
                        </p>
                    </div>
                )}
                <div className="container-fluid flex-grow">
                    <div className="row">
                        <div className="col-12 flex flex-col bidding-contract-step md:px-5">
                            {this.renderStepHeader()}

                            <div className="justify-center mb-3 bidding-wizard-sow min-h-[700px]">

                                <div className="lg:w-3/12 md:w-full p-0 items-stretch">

                                    <div className="flex flex-col-reverse lg:flex-col text-center">

                                        <div className="sow-steps-menu">
                                            {/*{this.props.project.hasUploadedManualContract() ? (*/}
                                            {/*    sowSteps.slice(-1).map((step, index) => this.renderSideBarNavLink(step, index))*/}
                                            {/*) : (*/}
                                            {sowSteps.map((step, index) => this.renderSideBarNavLink(step, index))}
                                            {/*)}*/}

                                        </div>
                                        {!acceptsStandardSOW && this.props.project.hasContract() && (
                                            <div className="my-3">
                                                <a href={this.props.project.latestContract().path}
                                                   className="btn btn-primary download-sow-btn"
                                                   target="_blank">
                                                    <i className="fa fa-file-alt mr-3"/>
                                                    {TB.tryTrans('start_project.contract.view_sow_btn')}
                                                </a>
                                            </div>
                                        )}
                                    </div>


                                </div>

                                <div className='lg:w-9/12 md:w-full text-center p-4'
                                     style={styles.stepContainer}>
                                    {shouldHandleStepNavigation && activeStepName && (
                                        <p style={styles.substepTitle}>
                                            {activeStepName}
                                        </p>
                                    )}
                                    <Routes>
                                        <Route
                                            index
                                            element={<Navigate to={{
                                                ...this.props.location,
                                                pathname: TB.first(sowSteps).SubstepSlug
                                            }} replace={true}/>}
                                        />

                                        {sowSteps.map(Step => {
                                            let shouldHandleApproval = !this.shouldHandleStepNavigation();
                                            let isLocked = this.props.project.isAwaitingKickoff() || ((!shouldHandleApproval)
                                                && Step !== BiddingContractApprovalDocumentsSubstep);
                                            return <Route key={`step${Step.SubstepSlug}`} path={Step.SubstepSlug}
                                                          element={
                                                              <Step {...this.props} isDisabled={this.state.isDisabled}
                                                                    isLocked={isLocked}
                                                                    canEditSOWForProject={canEditSOWForProject}
                                                                    startProject={this.startProject.bind(this)}
                                                                    makeRequest={this.makeRequest.bind(this)}
                                                                    cancelProjectSOWApproval={this.cancelProjectSOWApproval.bind(this)}
                                                                    approveStep={async () => {
                                                                        let completedSteps = [...this.state.completedSteps]

                                                                        if (ActiveStep === BiddingContractSummarySubstep && !this.props.project.hasApprovedLatestContract()) {
                                                                            return this.approveLatestSOWContractDetails();
                                                                        }
                                                                        if (!completedSteps.includes(ActiveStep)) {
                                                                            completedSteps.push(ActiveStep)
                                                                            await this.promisedState({completedSteps});
                                                                        }

                                                                        if (this.hasNextStep()) {
                                                                            return this.nextStep();
                                                                        }
                                                                    }}/>}/>
                                        })}

                                        <Route path="*" element={<Navigate
                                            to={{...this.props.location, pathname: TB.first(sowSteps).SubstepSlug}}
                                            replace={true}/>}/>


                                    </Routes>

                                    {shouldHandleStepNavigation && (
                                        <div className="flex flex-row mt-4 gap-4 items-center">
                                            {this.hasPrevStep() && (
                                                <button className="btn btn-outline-dark"
                                                        style={{width: 150}}
                                                        disabled={this.state.isDisabled}
                                                        onClick={this.prevStep.bind(this)}>
                                                    {TB.tryTrans('start_project.contract.prev_step_btn')}
                                                </button>
                                            )}

                                            <button
                                                className={TB.mapClass('btn btn-primary', {'disabled-edit-link': (!canCompleteSOWForProject && !this.hasNextStep())})}
                                                disabled={this.state.isDisabled || (!this.hasNextStep() && activeStepComplete)}
                                                onClick={async () => {
                                                    if (!canCompleteSOWForProject && !this.hasNextStep()) {
                                                        return TB.showPermissionError();
                                                    }

                                                    if (!activeStepComplete) {
                                                        let completedSteps = [...this.state.completedSteps];
                                                        completedSteps.push(ActiveStep);

                                                        await this.promisedState({completedSteps})
                                                    }

                                                    if (this.hasNextStep()) {
                                                        return this.nextStep()
                                                    }
                                                    await TB.wait(400)
                                                    return this.scrollToStep();
                                                }}
                                            >
                                                {(!canCompleteSOWForProject && this.hasNextStep()) ? 'Next' : TB.tryTrans('start_project.contract.next_step_btn')}
                                                {(!canCompleteSOWForProject && !this.hasNextStep()) && (
                                                    <i className="fa fa-lock ml-1"/>)}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ContractNav {...this.props} cancelProjectSow={() => this.cancelProjectSOW()}
                             isDisabled={this.state.isDisabled}/>
            </>
        );
    }
}

const ContractNav = (props) => {
    const {
        project,
        isLoading,
        requestSOW,
        cancelSOW,
        isDisabled: isProjectDisabled,
        isProjectUpdating
    } = useProject();
    const {auth} = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const isDisabled = isProjectDisabled || isProjectUpdating || props.isDisabled;

    if (!project ||isLoading || location.pathname.includes('profiles')) {
        return null;
    }

    const totalPositions = project.positions?.length;
    const filledPositions = project.positions.filter(posi => posi.hasBeenFilled());

    let acceptsStandardSOW = project.acceptsStandardSOW();
    let canRequestSOWForProject = auth?.canRequestSOWForProject(project)

    const cancelProjectSow = async() => {
        if (!canRequestSOWForProject) {
            return TB.showPermissionError();
        }
        return props.cancelProjectSow()
    }
    return (
        <Affix offsetBottom={-1} style={{zIndex: 25}}>
            <div className="bidding-footer-nav bidding-footer-alt drop-shadow-xl">
                <div className="w-full flex justify-end max-w-[1225px]">


                    <div className="flex items-center gap-x-8 md:gap-x-16">

                        <div>
                            {project.isBYO() ? (
                                project.hasRequestedSOW() ? (
                                    <p className="text-bold">
                                        <i className="fas fa-check mr-1 text-success"/>
                                        {`SoW ${project.isAwaitingContract() ? 'requested' : (project.isAwaitingKickoff() ? 'signed' : 'ready')} for ${filledPositions.length} positions`}
                                    </p>
                                ) : (
                                    <p className="text-bold">{`${filledPositions.length} of ${totalPositions} positions filled`}</p>
                                )
                            ) : (
                                project.hasRequestedSOW() ? (
                                    <p className="text-bold">
                                        <i className="fas fa-check mr-1 text-success"/>
                                        {`SoW ${project.isAwaitingContract() ? 'requested' : 'ready'} for team`}
                                    </p>
                                ) : (
                                    <p className="text-bold">{`Team Proposals Requested`}</p>
                                )
                            )}
                        </div>

                        {project.isBYO() && (
                            <div className="hidden flex-row items-center gap-2 md:flex">

                                {project.positions && project.positions.map((position, index) => {

                                    let hasBeenFilled = position.hasBeenFilled();
                                    let talent = {};

                                    if (hasBeenFilled && position.assigned_candidate) {
                                        talent = position.assignedCandidate()
                                    }

                                    let assigned = (hasBeenFilled && talent?.image_path);
                                    // let active = parseInt(positionId) === position.id;
                                    let key = `pos${position.id}-talent${talent?.id || 'unassigned'}`;

                                    return (
                                        <div key={key}
                                             className={TB.mapClass("position-swiper-slide", {
                                                 assigned,
                                                 unassigned: !assigned,
                                                 //  active
                                             })}>
                                            <div
                                                id={key}
                                                className={TB.mapClass("role-img", {
                                                    clickable: position.is_visible
                                                })}
                                                onClick={() => {
                                                    navigate({
                                                        pathname: `/client/project/bidding/${project?.id}/shortlist`,
                                                        search: '?from=contract'
                                                    })
                                                }}
                                            >
                                                {(hasBeenFilled && talent?.image_path) ? (
                                                    <UserImageCircle
                                                        user={talent}
                                                        hideTooltip={true}
                                                        size={50} className="img-fluid img-grayscale"/>
                                                ) : (
                                                    <span>
                                                        <i className="fa fa-user-circle"/>
                                                        <span className="position-index">
                                                            {index + 1}
                                                        </span>
                                                    </span>
                                                )}
                                            </div>

                                            <InfoTooltip type="dark" placement="bottom" target={key}>
                                                <div className="position-tooltip">
                                                    <p>{position.title}</p>
                                                    <p>
                                                        {hasBeenFilled ? talent.firstNamePlusInitial?.() : "TBD"}
                                                    </p>
                                                </div>
                                            </InfoTooltip>
                                        </div>
                                    )
                                })}
                            </div>
                        )}

                        {(!project.isAwaitingKickoff() || auth.canManageClients()) && acceptsStandardSOW && (
                            <div>
                                <button
                                    className={TB.mapClass('btn btn-outline-dark btn-outline-white flex flex-col text-center items-center', {
                                        'disabled-edit-link': !canRequestSOWForProject
                                    })}
                                    disabled={isDisabled}
                                    onClick={cancelProjectSow}>

                                    <span>
                                        <b>Cancel SoW</b>
                                        {!canRequestSOWForProject && (<i className="fa fa-lock ml-1"/>)}
                                    </span>
                                    <span className="font-medium">(go back to Shortlist)</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Affix>
    )
};


const ContractWizardStep = (props) => {
    const {project, update} = useProject();

    const location = useLocation();
    const navigate = useNavigate();
    const {
        toggleUsability,
        queryParams,
        isDisabled,
        goToStep
    } = useOutletContext();

    if (!project) return null;
    return (
        <BiddingContractStep
            project={project}
            updateProject={update}
            location={location}
            navigate={navigate}
            toggleUsability={toggleUsability}
            queryParams={queryParams}
            isDisabled={isDisabled}
            goToStep={goToStep}
        />
    )
}

export {
    ContractWizardStep
}
const styles = {
    stepContainer: {
        backgroundColor: 'white',
    },
    substepTitle: {
        textAlign: 'center',
        color: '#90A0B7',
        fontSize: 14,
        marginBottom: 25,
    },
};